import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { ITagInputProps, TagInput } from '../TagInput';

interface ITagFieldProps extends Partial<ITagInputProps> {
  name: string;
}
//FYI: this simplifies integration with Formik. See README
export const TagField: React.FC<ITagFieldProps> = ({ name, ...rest }) => {
  const formik = useFormikContext();
  const onChange = (value?: string[] | null) => {
    formik.setFieldTouched(name as never);
    formik.setFieldValue(name as never, value);
    if (rest.onChange) {
      rest.onChange(value);
    }
  };
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;
  const value = getIn(formik.values, name);

  return (
    <TagInput
      {...rest}
      errorText={errorText}
      value={value}
      onChange={onChange}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
